const translations: Record<string, string> = {
  "ak_nav_control": "Control",
  "ak_nav_user": "User",
  "ak_nav_no_energy_storage_at_this_solar_plant": "{{label}} — no energy storage at this solar plant",
  "ak_nav_overview": "Overview",
  "ak_nav_diagram": "Diagram",
  "ak_nav_inverters": "Inverters",
  "ak_nav_bess": "BESS",
  "ak_nav_equipment_monitoring": "Equipment monitoring",
  "ak_nav_fleet_control": "Fleet control",
  "ak_nav_curtailment_sko_dso": "Curtailment (SKO) / DSO",
  "ak_nav_events": "Events",
  "ak_nav_shift_log": "Shift log",
  "ak_nav_telemetry": "Telemetry",
  "ak_nav_reports": "Reports",
  "ak_nav_financial_result": "Financial result",
  "ak_nav_budget": "Budget",
  "ak_nav_dispatch_room": "Dispatch room",
  "ak_nav_forecast": "Forecast",
  "ak_nav_prices": "Prices",
  "ak_nav_trading_schedule": "Trading schedule",
  "ak_nav_generation_failed_http": "Generation failed: HTTP {{status}}",
  "ak_nav_export_failed_http": "Export failed: HTTP {{status}}",
  "ak_nav_generate_monthly_budget": "Generate monthly budget ({{stage}})",
  "ak_nav_price_scenario": "Price scenario: {{s}}",
  "ak_nav_d": "d",
  "ak_nav_mw": "MW",
  "ak_nav_trading_schedule_mockup": "Trading schedule (mockup)",
  "ak_nav_dam": "DAM",
  "ak_nav_bm_oper": "BM oper.",
  "ak_nav_bm_actual": "BM actual",
  "ak_nav_today": "Today",
  "ak_nav_previous_day": "Previous day",
  "ak_nav_next_day": "Next day",
  "ak_nav_period_start": "Period start",
  "ak_nav_period_end": "Period end",
  "ak_nav_previous_period": "Previous period",
  "ak_nav_next_period": "Next period",
  "ak_nav_export_xlsx": "Export XLSX",
  "ak_nav_schedule_submission_day": "Schedule submission day",
  "ak_nav_previous_month": "Previous month",
  "ak_nav_next_month": "Next month",
  "ak_nav_delivery_day": "Delivery day",
  "ak_nav_day": "Day",
  "ak_nav_month": "Month",
  "ak_nav_period": "Period",
  "ak_nav_chart": "Chart",
  "ak_nav_table": "Table",
  "ak_nav_actual_settlement_enter_the_actual_set": "Actual settlement - enter the actual settlement from the Balancing Group",
  "ak_nav_analytics_export_ae_xlsx_base_ecmwf_fo": "Analytics export (AE) - XLSX: Base/ECMWF forecast, actuals, DAM/BM prices, BESS charge/discharge for the selected period",
  "ak_nav_draft_t_5_for_approval": "Draft T-5 (for approval)",
  "ak_nav_final_version_t_1": "Final version T-1",
  "ak_nav_generate_monthly_budget_2": "Generate monthly budget",
  "ak_nav_export_monthly_budget_to_xlsx": "Export monthly budget to xlsx",
  "ak_nav_export_budget": "Export budget",
  "ak_nav_failed_to_generate_the_budget": "Failed to generate the budget",
  "ak_nav_export_failed": "Export failed",
  "ak_nav_draft": "draft",
  "ak_nav_final": "final",
  "ak_nav_test": "TEST",
  "ak_nav_test_stand_cabinet2_api_and_database_a": "Test stand (cabinet2). API and database are shared with production.",
};

export default translations;
